import { render, staticRenderFns } from "./DanhSachBanIn.vue?vue&type=template&id=780537d5&"
import script from "./BanIn.js?vue&type=script&lang=js&"
export * from "./BanIn.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports